import { useTranslation } from "react-i18next"

import { Check, Loader2 } from "@/components/icons"
import { cn } from "@/lib/utils"

type NodeExecutionIndicatorProps = {
  isExecuting: boolean
  isCompleted: boolean
  hasOutput?: boolean
}

export function NodeExecutionIndicator({
  isExecuting,
  isCompleted,
  hasOutput = false,
}: NodeExecutionIndicatorProps) {
  const { t } = useTranslation()

  if (!isExecuting && !isCompleted) {
    return null
  }

  const showExpandable = isCompleted && !isExecuting && hasOutput

  return (
    <div
      className={cn(
        "nodrag absolute -right-1 -bottom-1 z-10 flex h-6 w-6 items-center justify-center rounded-full shadow-md transition-[width,padding,background-color,border-color] duration-200",
        isExecuting && "border-foreground bg-success border",
        isCompleted &&
          !isExecuting &&
          "workflow-node-checkmark border-foreground bg-success border",
        showExpandable && "group/indicator cursor-pointer hover:w-auto hover:px-2.5"
      )}
    >
      {isExecuting ? (
        <Loader2 className="text-success-foreground size-3.5 animate-spin" />
      ) : (
        <>
          <Check className="text-success-foreground size-3.5 shrink-0" strokeWidth={3} />
          {showExpandable && (
            <span className="text-success-foreground ml-1.5 hidden text-[11px] font-medium whitespace-nowrap group-hover/indicator:inline">
              {t("workflowEditor.nodeOutput.viewOutput", "View output")}
            </span>
          )}
        </>
      )}
    </div>
  )
}
